package io.horion.auth.api.repository

import io.horion.auth.api.models.domain.profile.User
import io.horion.auth.api.models.domain.profile.UserRequest
import io.horion.auth.api.models.response.Response
import io.horion.auth.api.services.ProfileService
import io.horion.auth.utils.LocalStorageManager

class ProfileRepositoryImpl(
    private val profileService: ProfileService,
) : ProfileRepository {

    override suspend fun saveUser(firstName: String, lastName: String, avatar: String): Response {
        return try {
            val savedProfile = LocalStorageManager.getUserProfile()
                ?: return Response(false, "Profil local introuvable. Veuillez vous re-connecter.")

            val profile = UserRequest(
                userUuid = savedProfile.id,
                firstName = firstName,
                lastName = lastName,
                avatar = avatar,
                role = savedProfile.role,
                city = savedProfile.city,
                country = savedProfile.country,
                countryCode = savedProfile.countryCode,
                timezone = savedProfile.timezone,
            )

            val response = profileService.saveUser(profile)

            if (response.success) {
                val updatedLocalProfile = savedProfile.copy(
                    firstName = firstName,
                    lastName = lastName,
                    avatar = avatar,
                )
                LocalStorageManager.saveUserProfile(updatedLocalProfile)
            }

            response

        } catch (e : Exception) {
            Response(false,"Serveur injoignable, reesayer plus tard")
        }
    }

    override suspend fun updateUser(firstName: String, lastName: String, avatar: String ): Response {
        return try {
            val savedProfile = LocalStorageManager.getUserProfile()
                ?: return Response(false, "Profil local introuvable. Veuillez vous re-connecter.")

            val profile = UserRequest(
                userUuid = savedProfile.id,
                firstName = firstName,
                lastName = lastName,
                avatar = avatar,
                role = savedProfile.role,
                city = savedProfile.city,
                country = savedProfile.country,
                countryCode = savedProfile.countryCode,
                timezone = savedProfile.timezone
            )

            val response = profileService.updateUser(profile)

            if (response.success) {
                val updatedLocalProfile = savedProfile.copy(
                    firstName = firstName,
                    lastName = lastName,
                    avatar = avatar,
                )
                LocalStorageManager.saveUserProfile(updatedLocalProfile)
            }

            response
        } catch (e : Exception) {
            Response(false,"Serveur injoignable, reesayer plus tard")
        }
    }

    override suspend fun readUser(): User? {
        return try {
            val user = profileService.readUser()
            // Optionnel : si l'appel serveur réussit, on rafraîchit le cache local
            if (user != null) {
                // LocalStorageManager.saveUserProfile(user.toUserProfile())
            }
            user
        } catch (e : Exception) {
            null
        }
    }
}